module.exports = __webpack_public_path__ + "media/wrong.e6c83ac9.wav";